export function unsplashImageUrl(photoId: string, width: number, height: number): string {
    return `https://images.unsplash.com/${photoId}?q=80&w=${width}&h=${height}&fit=crop&auto=format`;
}
